const apiPrefix = '/api/v1'
const apiPrefixV2 = '/api/v2'
const apiPrefixAdmin = '/api/admin'

const routes = {
  // TODO: create dynamic generation of routes.
  login: _ => apiPrefix + '/login',
  auth: {
    get_code: _ => [apiPrefix, '/auth', '/get-code'].join('').trim(),
    get_token: _ => [apiPrefix, '/auth', '/get-token'].join('').trim(),
    logout: _ => [apiPrefix, '/auth', '/logout'].join('').trim()
  },
  users: {
    list: _ => apiPrefixAdmin + '/users',
    concrete: id => [apiPrefix, '/users', '/', id].join('').trim(),
    changePassword: _ => [apiPrefix, '/user', '/change-password'].join('').trim(),
    profile: _ => [apiPrefix, '/user', '/profile'].join('').trim(),
    getAuthToken: id => [apiPrefix, '/users', '/', id, '/get-auth'].join('').trim(),
    billing: _ => [apiPrefix, '/user', '/billing'].join('').trim(),
    currentOrganization: _ => [apiPrefix, '/user', '/current-organization'].join('').trim(),
    initChangeEmail: _ => [apiPrefix, '/user', '/email', '/change', '/init'].join('').trim(),
    oldEmailOtpConfirm: _ =>
      [apiPrefix, '/user', '/email', '/change', '/confirm-old'].join('').trim(),
    newEmailOtpConfirm: _ =>
      [apiPrefix, '/user', '/email', '/change', '/confirm-new'].join('').trim(),
    newEmail: _ => [apiPrefix, '/user', '/email', '/change', '/email'].join('').trim()
  },
  currentuser: {
    concrete: id => [apiPrefix, '/users', '/', id].join('').trim()
  },
  document: {
    list: _ => apiPrefix + '/documents',
    listV2: _ => apiPrefixV2 + '/documents',
    concrete: id => [apiPrefix, '/documents', '/', id].join('').trim(),
    sign: id => [apiPrefix, '/documents', '/', id, '/sign'].join('').trim(),
    send: id => [apiPrefix, '/documents', '/', id, '/send'].join('').trim(),
    download: id => [apiPrefix, '/documents', '/', id, '/download'].join('').trim(),
    participants: id => [apiPrefix, '/documents', '/', id, '/participants'].join('').trim(),
    participantsV2: id => [apiPrefixV2, '/documents', '/', id, '/participants'].join('').trim(),
    signatures: id => [apiPrefix, '/documents', '/', id, '/signatures'].join('').trim(),
    approve: id => [apiPrefix, '/documents', '/', id, '/approve'].join('').trim(),
    reject: id => [apiPrefix, '/documents', '/', id, '/reject'].join('').trim(),
    toArchive: id => [apiPrefix, '/documents', '/', id, '/to-archive'].join('').trim(),
    fromArchive: id => [apiPrefix, '/documents', '/', id, '/from-archive'].join('').trim(),
    documentLink: id => [apiPrefix, '/documents', '/', id, '/links'].join('').trim(),
    downloadDocuments: _ => [apiPrefix, '/downloads'].join('').trim(),
    downloadStatus: id => [apiPrefix, '/downloads', '/', id, '/status'].join('').trim(),
    downloadArchive: id => [apiPrefix, '/downloads', '/', id, '/download'].join('').trim(),
    tags: id => [apiPrefix, '/documents', '/', id, '/tags'].join('').trim(),
    concreteTag: (id, tagId) =>
      [apiPrefix, '/documents', '/', id, '/tags', '/', tagId].join('').trim(),
    attachTags: _ => [apiPrefix, '/documents', '/attach-tags'].join('').trim(),
    fillDynamicFields: id => [apiPrefix, '/documents', '/', id, '/fields'].join('').trim(),
    documentsParticipants: _ => [apiPrefix, '/participants'].join('').trim(),
    convertToPdf: id => [apiPrefix, '/documents', '/', id, '/to-pdf'].join('').trim(),
    approvals: id => [apiPrefix, '/documents', '/', id, '/approvals'].join('').trim(),
    archive: _ => [apiPrefix, '/archive', '/documents'].join('').trim(),
    logs: id => [apiPrefix, '/documents', '/', id, '/logs'].join('').trim(),
    cancel: id => [apiPrefix, '/documents', '/', id, '/cancel'].join('').trim()
  },
  admindocument: {
    list: _ => apiPrefixAdmin + '/documents',
    concrete: id => [apiPrefixAdmin, '/documents', '/', id].join('').trim()
  },
  documentsignature: {
    concrete: id => [apiPrefix, '/documents', '/', id, '/signatures'].join('').trim()
  },
  documentstatus: {
    list: _ => apiPrefixAdmin + '/document-statuses'
  },
  adminsignature: {
    list: _ => apiPrefixAdmin + '/signatures'
  },
  documentlog: {
    list: _ => apiPrefixAdmin + '/document-logs'
  },
  documenttype: {
    list: _ => apiPrefix + '/document-types'
  },
  organization: {
    list: _ => apiPrefix + '/organizations',
    concrete: id => [apiPrefix, '/organizations', '/', id].join('').trim(),
    within(model, property = null) {
      return [
        routes[model.constructor.entity].concrete(model[model.constructor.primaryKey]),
        property
      ]
        .join('')
        .trim()
    },
    synchronize: id => [apiPrefix, '/organizations', '/', id, '/sync'].join('').trim(),
    cashRegisters: id => ['/organizations', '/', id, '/cash-registers'].join('').trim(),
    sendTaxAuthData: _ => ['/tax', '/update-token'].join(''),
    exists: edrpou => [apiPrefix, '/organizations', '/', edrpou, '/exists'].join('').trim(),
    restore: id => [apiPrefix, '/organizations', '/', id, '/restore'].join('').trim(),
    billing: id => [apiPrefix, '/organizations', '/', id, '/billing'].join('').trim(),
    join: id => [apiPrefix, '/organizations', '/', id, '/join'].join('').trim()
  },
  adminorganization: {
    list: _ => apiPrefixAdmin + '/organizations',
    concrete: id => [apiPrefixAdmin, '/organizations', '/', id].join('').trim()
  },
  organizationusers: {
    list: _ => apiPrefix + '/organization-users',
    concrete: id => [apiPrefix, '/organization-users', '/', id].join('').trim(),
    accept: id => [apiPrefix, '/organization-users', '/', id, '/accept'].join('').trim(),
    reject: id => [apiPrefix, '/organization-users', '/', id, '/reject'].join('').trim(),
    users: id => [apiPrefix, '/organizations', '/', id, '/users'].join('').trim(),
    notify: id => [apiPrefix, '/organization-users', '/', id, '/notify'].join('').trim()
  },
  adminorganizationusers: {
    list: _ => apiPrefixAdmin + '/organization-users'
  },
  participant: {
    concrete: id => [apiPrefix, '/participants', '/', id].join('').trim()
  },
  adminparticipant: {
    list: _ => apiPrefixAdmin + '/participants'
  },
  edsKey: {
    check: _ => '/eds-keys/check'
  },
  get organizationsearch() {
    return this.organization
  },
  shortcode: {
    concrete: id => [apiPrefix, '/shortcodes', '/', id].join('').trim()
  },
  tag: {
    list: _ => apiPrefix + '/tags',
    adminList: _ => apiPrefixAdmin + '/tags',
    concrete: id => [apiPrefix, '/tags', '/', id].join('').trim()
  },
  accesstoken: {
    list: _ => apiPrefix + '/access-tokens',
    concrete: id => [apiPrefix, '/access-tokens', '/', id].join('').trim()
  },
  bulksignature: {
    concrete: id => [apiPrefix, '/bulk-signatures', '/', id].join('').trim()
  },
  template: {
    list: _ => apiPrefix + '/templates',
    concrete: id => [apiPrefix, '/templates', '/', id].join('').trim(),
    fields: id => [apiPrefix, '/templates', '/', id, '/fields'].join('').trim(),
    concreteFields: (id, fieldId) =>
      [apiPrefix, '/templates', '/', id, '/fields', '/', fieldId].join('').trim(),
    toDocument: id => [apiPrefix, '/templates', '/', id, '/document'].join('').trim(),
    aiGenerate: id => [apiPrefix, '/templates', '/', id, '/ai'].join('').trim()
  },
  admintemplate: {
    list: _ => apiPrefixAdmin + '/templates',
    concrete: id => [apiPrefixAdmin, '/templates', '/', id].join('').trim()
  },
  gallery: {
    list: _ => [apiPrefix, '/gallery', '/templates'].join('').trim(),
    concrete: id => [apiPrefix, '/gallery', '/templates', '/', id].join('').trim(),
    cloneTemplate: id => [apiPrefix, '/gallery', '/templates', '/', id, '/clone'].join('').trim()
  },
  gallerycategory: {
    list: _ => [apiPrefix, '/gallery', '/categories'].join('').trim()
  },
  folder: {
    list: _ => apiPrefix + '/folders',
    concrete: id => [apiPrefix, '/folders', '/', id].join('').trim()
  },
  comment: {
    concrete: id => [apiPrefix, '/comments', '/', id].join('').trim(),
    documentComments: documentId =>
      [apiPrefix, '/documents', '/', documentId, '/comments'].join('').trim()
  },
  contact: {
    list: _ => apiPrefix + '/contacts',
    concrete: id => [apiPrefix, '/contacts', '/', id].join('').trim(),
    import: _ => [apiPrefix, '/contacts', '/import'].join('').trim()
  },
  onboarding: {
    list: _ => apiPrefix + '/onboarding'
  },
  billing: {
    list: _ => apiPrefixAdmin + '/billings',
    trial: _ => [apiPrefix, '/billing', '/trial'].join('').trim(),
    dashboard: _ => [apiPrefix, '/billing', '/dashboard'].join('').trim(),
    purchase: _ => [apiPrefix, '/billing', '/purchase'].join('').trim(),
    tariffs: _ => [apiPrefix, '/billing', '/tariffs'].join('').trim(),
    activities: _ => [apiPrefix, '/billing', '/activities'].join('').trim(),
    consumptions: _ => [apiPrefix, '/billing', '/consumptions'].join('').trim(),
    apply: _ => [apiPrefixAdmin, '/billing', '/apply'].join('').trim()
  },
  tariff: {
    list: _ => apiPrefixAdmin + '/tariffs'
  },
  invoice: {
    list: _ => apiPrefix + '/invoices',
    concrete: id => [apiPrefix, '/invoices', '/', id].join('').trim(),
    payByBank: id => [apiPrefix, '/invoices', '/', id, '/pay-by-bank'].join('').trim(),
    payByCard: id => [apiPrefix, '/invoices', '/', id, '/pay-by-card'].join('').trim(),
    payByBalance: id => [apiPrefix, '/invoices', '/', id, '/pay-by-balance'].join('').trim()
  },
  admininvoice: {
    list: _ => apiPrefixAdmin + '/invoices',
    downloadInvoice: id => [apiPrefixAdmin, '/invoices', '/', id, '/pdf'].join('').trim()
  },
  act: {
    list: _ => apiPrefix + '/acts',
    downloadAct: id => [apiPrefix, '/acts', '/', id, '/pdf'].join('').trim(),
    downloadReconciliationAct: _ => [apiPrefix, '/generate-reconciliation-act'].join('').trim(),
    sign: id => [apiPrefix, '/acts', '/', id, '/sign'].join('').trim()
  },
  adminact: {
    list: _ => apiPrefixAdmin + '/acts',
    downloadAct: id => [apiPrefixAdmin, '/acts', '/', id, '/pdf'].join('').trim(),
    actsTotal: _ => [apiPrefixAdmin, '/acts-total'].join('').trim()
  },
  payment: {
    list: _ => apiPrefixAdmin + '/payments',
    concrete: id => [apiPrefixAdmin, '/payments', '/', id].join('').trim()
  },
  taxbill: {
    list: _ => apiPrefixAdmin + '/tax-bills',
    concrete: id => [apiPrefixAdmin, '/tax-bills', '/', id].join('').trim(),
    status: _ => [apiPrefixAdmin, '/tax-bills', '/status'].join('').trim(),
    export: _ => [apiPrefixAdmin, '/tax-bills', '/export'].join('').trim(),
    taxBillsTotal: _ => [apiPrefixAdmin, '/tax-bills-total'].join('').trim()
  },
  reconciliationact: {
    list: _ => apiPrefixAdmin + '/reconciliation-acts'
  },
  clientbalance: {
    list: _ => apiPrefixAdmin + '/client-balances'
  },
  session: {
    list: _ => apiPrefixAdmin + '/sessions',
    concrete: id => [apiPrefixAdmin, '/sessions', '/', id].join('').trim()
  },
  adminperiod: {
    list: _ => apiPrefixAdmin + '/periods'
  },
  integrations: {
    list: _ => apiPrefix + '/roaming-integrations',
    concrete: id => [apiPrefix, '/roaming-integrations', '/', id].join('').trim()
  },
  archivetrigger: {
    list: _ => apiPrefix + '/archive-triggers',
    concrete: id => [apiPrefix, '/archive-triggers', '/', id].join('').trim()
  },
  peopleforce: {
    list: _ => apiPrefix + '/people-forces',
    concrete: id => [apiPrefix, '/people-forces', '/', id].join('').trim(),
    connection: _ => [apiPrefix, '/people-forces', '/connection'].join('').trim()
  },
  savedroute: {
    list: _ => apiPrefix + '/routes',
    concrete: id => [apiPrefix, '/routes', '/', id].join('').trim()
  },
  creditcardtokens: {
    list: _ => apiPrefix + '/credit-card-tokens',
    concrete: id => [apiPrefix, '/credit-card-tokens', '/', id].join('').trim()
  }
}

export default routes
